/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const CLEAR_ROMOTION_DATA = 'MFE/MBP-CHECKOUT/CLEAR_ROMOTION_DATA';
export const SET_MFE_BANNER_CODES_ATTEMPTS = 'MFE/MBP-CHECKOUT/SET_MFE_BANNER_CODES_ATTEMPTS';
export const MFE_PROMOTION_REDIRECT_TO_AFFILIATE = 'MFE/MBP-CHECKOUT/PROMOTION_REDIRECT_TO_AFFILIATE';
export const MFE_CLEAR_PROMO_AFFILIATE = 'MFE/MBP-CHECKOUT/MFE_CLEAR_PROMO_AFFILIATE';
export const MFE_SET_PROMOTION_LOAD = 'MFE/MBP-CHECKOUT/MFE_SET_PROMOTION_LOAD';

export const PROMOTION_ADD = 'MFE/CHECKOUT/PROMOTION_ADD';
export const PROMOTION_REMOVE = 'MFE/CHECKOUT/PROMOTION_REMOVE';
export const PROMOTION_SUCCESS = 'MFE/CHECKOUT/PROMOTION_SUCCESS';
export const PROMOTION_ERROR = 'MFE/CHECKOUT/PROMOTION_ERROR';
